import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { canEditWaivers, canViewAnyWaiver, canViewWaivers, setHelpPage, setWindowTitle } from '../configTdm';
import WaiverAirlineList from './WaiverAirlineList';
import WaiverList from './WaiverList';
import { getProperty } from '../fsConfig';

const WaiverOverview: React.FC = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState<string>('');
  const user = getProperty('session', {});

  const [title, setTitle] = useState<string>('WAIVERS');
  
  useEffect(() => {
    if (!canViewWaivers()) {
      navigate('/home');
    }
    setWindowTitle('Waivers');
    setHelpPage('helpWaiverList');
  }, [navigate]);

  const onIssuingAirlineUpdate = (issuingAirlineCode: string) => {
    setSearch(issuingAirlineCode);
  };

  return (
    <div className="row">
      <div className="row waiver-title">
        <div className="col-md-12 align-middle">
          {title}
          <div className="pull-right">
            <WaiverAirlineList 
              canViewAllWaivers={canViewAnyWaiver} 
              updateIssuingAirlineCode={onIssuingAirlineUpdate} 
            />
            {canEditWaivers() && (
              <>
                <span className="waiver-header-link">
                  <a href="/waivers/new/edit">Add a waiver</a>
                </span>
                <span className="waiver-header-link">
                  <a href="/waivers/configurations">Edit defaults</a>
                </span>
              </>
            )}
          </div>
        </div>
      </div>

      <WaiverList
        user={user} 
        canEditWaivers={canEditWaivers} 
        canViewAllWaivers={canViewAnyWaiver} 
        search={search} 
      />
    </div>
  );
};

export default WaiverOverview;